import { owaDate, addDays } from 'owa-datetime';
import { formatMonthDayYear } from 'owa-datetime-formatters';
import { getUserTimeZone } from 'owa-session-store';

/**
 * Util to get 90 days expiration date.
 */
export default function getExpirationDate(): string {
    const start = owaDate(getUserTimeZone());
    const expirationDate = addDays(start, 90);
    return formatMonthDayYear(expirationDate);
}
